import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { pathFor, type Lang } from '../../router/paths';

interface StickyBookingProps {
  show?: boolean;
}

export default function StickyBooking({ show = true }: StickyBookingProps) {
  const { t, i18n } = useTranslation();
  const lang: Lang = i18n.language === 'en' ? 'en' : 'de';

  return (
    <div className={`fixed bottom-0 left-0 right-0 bg-white py-2.5 sm:py-4 px-4 sm:px-6 shadow-lg z-40 transition-transform duration-300 border-t border-gray-200 ${ /* MOBILE: py-2.5 statt py-3 */
      show ? 'translate-y-0' : 'translate-y-full'
    }`}>
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs sm:text-sm font-medium truncate text-gray-900">
            <span className="sm:hidden">{t('stickyTitleMobile')}</span>
            <span className="hidden sm:inline">{t('stickyTitle')}</span>
          </p>
          <p className="text-[11px] sm:text-xs truncate hidden sm:block text-gray-800">{t('stickySubtitle')}</p>
        </div>
        <Link
          to={pathFor('buchen', lang)}
          onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
          className="flex-shrink-0 border border-amber-700 text-amber-700 px-4 sm:px-6 py-2 sm:py-2.5 rounded-md text-xs sm:text-sm font-medium hover:bg-amber-50 transition-colors whitespace-nowrap cursor-pointer"
        >
          {t('stickyButton')}
        </Link>
      </div>
    </div>
  );
}
